<!-- =========================================================================================
    File Name: tableFilterSorter.vue
    Description: Add filter and sorting functionality to table
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
<b-overlay
    :show="show"
    :variant="variant"
    :opacity="opacity"
    :blur="blur"
    rounded="lg"
    spinner-variant="primary"
  >
  <b-card>
    <h4 class="heading float-left">{{ $t("RelativeDetails") }}</h4>
    <router-link
      :to="'/company/user/relatives/' + relative.unio_user_id"
      class="float-right"
    >
      <b-button variant="primary" class="primary">{{ $t("Back") }}</b-button>
    </router-link>
    <div class="export-table description">
      <div class="vx-col">
         <b-table-simple responsive>
              <b-tbody>
        <b-tr>
          <b-td vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
            <span class="font-semibold">{{ $t("FirstName") }}</span>
          </b-td>
          <b-td vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
            <span>{{ relative.first_name }}</span>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
            <span class="font-semibold">{{ $t("LastName") }}</span>
          </b-td>
          <b-td vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
            <span>{{ relative.last_name }}</span>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
            <span class="font-semibold">{{ $t("DegreeOfKinship") }}</span>
          </b-td>
          <b-td vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
            <span>{{ relative.degree_of_kinship }}</span>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
            <span class="font-semibold">{{ $t("DateOfBirth") }}</span>
          </b-td>
          <b-td vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
            <span>{{ relative.date_of_birth }}</span>
          </b-td>
        </b-tr>

        <b-tr>
          <b-td vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
            <span class="font-semibold">{{ $t("BirthPlace") }}</span>
          </b-td>
          <b-td vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
            <span>{{ relative.birth_place }}</span>
          </b-td>
        </b-tr>

        <b-tr>
          <b-td vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
            <span class="font-semibold">{{ $t("Status") }}</span>
          </b-td>
          <b-td vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
            <span>{{ $t(relative.status) }}</span>
          </b-td>
        </b-tr>

        <b-tr>
          <b-td vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
            <span>
              <b class="mb-2">{{ $t("Document_1") }}:</b>
            </span>
          </b-td>
          <b-td vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
            <span>
              <div v-if="relative.first_document">
                <div class="vx-col mt-3" style="word-break: break-all">
                  <div v-if="relative.first_document.document.includes('.pdf')">
                    <a
                      target="_blank"
                      class="mt-5"
                      v-bind:href="relative.first_document.path"
                      >{{ relative.first_document.path }}</a
                    >
                  </div>
                  <a
                    target="_blank"
                    v-else
                    v-bind:href="relative.first_document.path"
                  >
                    <img
                      class="custom-image-class"
                      width="300"
                      :src="relative.first_document.path"
                    />
                  </a>
                </div>
              </div>
            </span>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
            <b class="mb-2">{{ $t("Document_2") }}:</b>
          </b-td>
          <b-td vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
            <div v-if="relative.second_document">
              <div class="vx-col mt-3" style="word-break: break-all">
                <div v-if="relative.second_document.document.includes('.pdf')">
                  <a
                    target="_blank"
                    class="mt-5"
                    v-bind:href="relative.second_document.path"
                    >{{ relative.second_document.path }}</a
                  >
                </div>
                <a
                  target="_blank"
                  v-else
                  v-bind:href="relative.second_document.path"
                >
                  <img
                    class="custom-image-class"
                    width="300"
                    :src="relative.second_document.path"
                  />
                </a>
              </div>
            </div>
          </b-td>
        </b-tr>
              </b-tbody>
              </b-table-simple>
      </div>
    </div>
  </b-card>
</b-overlay>
</template>

<script>
import vSelect from "vue-select";
export default {
  components: {
    vSelect,
  },
  data() {
    return {
      relative: [],
      departments: [],
      id: "",
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      sec: 2,
      counter: 0,
    };
  },
  watch: {
    "$i18n.locale": {
      handler: function (value) {
        this.getRelative();
        this.loadLocale(value);
      },
    },
  },
  created() {
    this.id = this.$route.params.id;
    this.getRelative();
  },

  methods: {
    /**
     *  getstaffs method get all companies from company list
     **/

    getRelative() {
      this.show = true;
      this.$store
        .dispatch("getRelative", this.id)
        .then((res) => {
          this.show = false;
          this.relative = res.data.data;
          // relation

          let user_list = this.relative.degree_of_;

          // this.user.forEach((element, index) => {
          let relation =
            this.relative.degree_of_kinship.charAt(0).toUpperCase() +
            this.relative.degree_of_kinship.slice(1);
          user_list = relation.replace(/[^a-zA-Z ]/g, "").replace(/ /g, "");
          console.log(relation);
          // });
          this.relative.degree_of_kinship = this.$t(user_list);
          // relation
          this.relative.status =
            this.relative.status == 1
              ? "Accepted"
              : this.relative.status == 2
              ? "Rejected"
              : "Pending";
        })
        .catch((error) => {
          this.$log.error(
            "File : Show.vue | Function : getRelative() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
  },
};
</script>

<style lang="stylus" scope>
.heading {
  margin-bottom: 20px;
}

.add {
  position: absolute;
  margin-top: 10px;
}

.action {
  margin-left: 20px;
  display: inline;
}

.space {
  margin-top: 20px;
}

.vs-row {
  padding: 10px;
}

.custom-image-class {
  box-shadow: 0px 0px 4px #888;
  padding: 5px;
}
.description td {
    border: none !important;
    padding: 10px !important;
    color: #626262;
    width: 50%
}
</style>